
<template>
  <div class="sidebar-right">
    <h3>Stil bearbeiten</h3>
    <div>
      <label for="margin">Margin</label>
      <input type="number" id="margin" v-model="margin" @input="updateStyle('margin', margin)" />
    </div>
    <div>
      <label for="padding">Padding</label>
      <input type="number" id="padding" v-model="padding" @input="updateStyle('padding', padding)" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['initialMargin', 'initialPadding'],
  data() {
    return {
      margin: this.initialMargin || 0,
      padding: this.initialPadding || 0,
    };
  },
  methods: {
    updateStyle(styleProp, value) {
      // Emit an event to update the style in the editor view
      this.$emit('update-style', styleProp, value);
    },
  },
  watch: {
    initialMargin(newVal) {
      this.margin = newVal;
    },
    initialPadding(newVal) {
      this.padding = newVal;
    },
  },
};
</script>
